/* eslint-disable no-unused-vars */
import { IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React from 'react';
import { CustomHelperText, Wrapper } from './EditableTextField.Styles';
var EditButton = function (_a) {
    var onEditClick = _a.onEditClick;
    return (React.createElement("div", { style: { cursor: 'pointer', display: 'inline' } },
        React.createElement(IconButton, { onClick: function () {
                onEditClick();
            } },
            React.createElement(EditOutlinedIcon, { style: { fontSize: '.7em' } }))));
};
export var EditableTextField = function (_a) {
    var form = _a.form, field = _a.field, label = _a.label;
    var _b = React.useState(false), isTextFocused = _b[0], setIsTextFocused = _b[1];
    var _c = React.useState(form.errors[field.name]), validationError = _c[0], setValidationError = _c[1];
    var handleChange = function (event) {
        form.setFieldValue(field.name, event.target.value);
    };
    var willError = form.touched[field.name] && !!form.errors[field.name];
    return (React.createElement(Wrapper, null,
        !isTextFocused ? (React.createElement("div", null,
            React.createElement("div", { style: {
                    display: 'inline',
                    color: !willError ? 'inherit' : 'red'
                } }, field.value),
            React.createElement(EditButton, { onEditClick: function () {
                    setIsTextFocused(true);
                } }))) : (React.createElement(TextField, { style: { width: 300 }, autoFocus: true, label: label, value: field.value, onChange: handleChange, onBlur: function () {
                setIsTextFocused(false);
                form.setFieldTouched(field.name, true);
            } })),
        willError && (React.createElement(CustomHelperText, { error: willError }, form.errors[field.name]))));
};
EditableTextField.defaultProps = {
    type: 'text'
};
//# sourceMappingURL=EditableTextField.js.map